import React, { useEffect, useState } from 'react'
import VehicleCard from './vehicle-card';
import { useAppDispatch } from '../../../../hooks/hooks';
import { vehicles } from '../../../../redux/vehicles/action';
import { useSelector } from 'react-redux';
import queryString from "query-string";
import CryptoJS from 'crypto-js';
import { selectVehiclesListItems } from '../../../../redux/vehicles/selector';
import Popup from '../../../../common/components/popup';
import ModalEstimateComponent from './modal-estimate-details';
import { deepCopy } from '../../../../common/services/common.service';
import { selectCategoriesListItems } from '../../../../redux/categories/selector';
import { categories } from '../../../../redux/categories/action';
import { selectCurrent } from '../../../../redux/settings/selectors';
import _ from 'lodash';
import { selectShippingTypesListItems } from '../../../../redux/shippingTypes/selector';
import { shippingTypes } from '../../../../redux/shippingTypes/action';
import { cargoQuotes } from '../../../../redux/cargo-quotes/action';
import { selectCargoLeadsCreatedItem } from '../../../../redux/cargo-lead/selector';
import { useNavigate } from 'react-router-dom';
import { cargoLeads } from '../../../../redux/cargo-lead/action';
import ModalQuotesDetailsComponent from './modal-quotes-detail';
import { selectCmsSettingsListItems } from '../../../../redux/cmsSettings/selector';
import { addPayment } from '../../../../redux/addPayment/action';
import { selectPaymentMethodsQueryItems } from '../../../../redux/payment-methods/selector';
import { selectProductsListItems } from '../../../../redux/products/selector';
import moment from 'moment';
import { selectOrganizationUnitsListItems } from '../../../../redux/organizationUnits/selector';
import { orders } from '../../../../redux/orders/action';
import storePersist from '../../../../redux/storePersist';
import { selectOrdersCreatedItem } from '../../../../redux/orders/selector';
import { selectCargoQuotesCreatedItem } from '../../../../redux/cargo-quotes/selector';
import CommonModal from '../../../../models/common-modal';
import ModalLeadComponent from './cargoleadEdit';
import { selectProductTypesListItems } from '../../../../redux/product-types/selector';
import { productTypes } from '../../../../redux/product-types/action';
import CommonModalMobile from '../../../../models/common-modal-mobile';
import PopupMobile from '../../../../common/components/popup-mobile.component';
import { toast } from 'react-toastify';
import ModalEwayComponent from './e-way-bill-modal';

const CargoOrderBookingMobile = () => {
    const result = useSelector(selectCurrent)
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const [isOpenPayment, setIsOpenPayment] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const leadCreateData = useSelector(selectCargoLeadsCreatedItem)
    const vehicleData = useSelector(selectVehiclesListItems)
    const [orderItem, setOrderItem] = useState<any>(undefined);
    const [leadItem, setLeadItem] = useState<boolean>(false);
    const [
        mediaFiles,
        setMediaFiles
    ] = useState<any>()
    const categoryListItems = useSelector(selectCategoriesListItems)
    const [enableConfirm, setEnableConfirm] = useState<boolean>(false)
    const [enablePlaceOrder, setEnablePlaceOrder] = useState(false);
    const [selectedEstimateItem, setSelectedEstimateItem] = useState<any>({
        Name: result?.cargoLead?.Name || '',
        PhoneNumber: result?.cargoLead?.PhoneNumber || '',
        Pickup: result?.searchedLocation?.description || '',
        Drop: result?.searchedToLocation?.description || '',
        DropName: result?.cargoLead?.DropName || '',
        DropPhoneNumber: result?.cargoLead?.DropPhoneNumber || ''
    });

    const [isOrderPlaced, setIsOrderPlaced] = useState<any>(false);
    const [isPaymentAdded, setIsPaymentAdded] = useState<any>(false);
    const [razorpaySettings, setRazorpaySettings] = useState<any>([])
    const [paymentGateway, setPaymentGateway] = useState<any>([]);
    const [generateIds, setGenerateIds] = useState<any>([]);
    const [selectedVehicleItem, setSelectedVehicleItem] = useState<any>({
    });
    const [paymentSelectedInput, setPaymentSelectedInput] = useState<any>(undefined);
    const [paymentMode, setPaymentMode] = useState<any>(undefined);
    const [selected, setSelected] = useState<any>();
    const ProductLists = useSelector(selectProductsListItems)
    const [pickupLocations, setPickupLocations] = useState<any>({
        name: result?.searchedLocation?.name || '',
        lat: result?.searchedLocation?.lat || '',
        lng: result?.searchedLocation?.lng || '',
        pincode: result?.searchedLocation?.pincode || '',
        description: result?.searchedLocation?.description || '',
    });
    const [dropLocations, setDropLocations] = useState<any>({
        name: result?.searchedToLocation?.name || '',
        lat: result?.searchedToLocation?.lat || '',
        lng: result?.searchedToLocation?.lng || '',
        pincode: result?.searchedToLocation?.pincode || '',
        description: result?.searchedToLocation?.description || '',
    });
    var tenantId = storePersist.get('guestTokenMetadata')?.current?.result?.TokenMetadata?.TenantId;
    var storeId = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization?.StoreId;
    const orderDetails = useSelector(selectOrdersCreatedItem)
    const MODE = 'secure';
    const userProfileData = storePersist?.get("userProfile")?.current?.items[0]?.Message;

    const paymentMethodQuery = useSelector(selectPaymentMethodsQueryItems)
    const shippingTypesDetails = useSelector(selectShippingTypesListItems)
    const quoteDetails = useSelector(selectCargoQuotesCreatedItem)
    const paymentSettings = useSelector(selectCmsSettingsListItems)
    const organizationUnitLists = useSelector(selectOrganizationUnitsListItems)
    const productTypesListItems = useSelector(selectProductTypesListItems)
    const productTypeCargo = productTypesListItems?.result?.items.filter(
        (data: any) => data.IsCargoOrder === true
    )
    const isOpenComponent = quoteDetails?.result?.Records[0]?.message?.order?.LinkedItems[0]?.value?.value >= 50000;
    const generateUniqueId = () => {
        const randomPart = Math.random().toString(36).substr(2, 9); // Random part
        const timestampPart = Date.now().toString(36); // Timestamp part
        return `${randomPart}-${timestampPart}`;
    };

    const generateIdValue = () => {
        const newItem = {
            transaction_id: generateUniqueId(),
            message_id: generateUniqueId(),
            fulfillment_id: generateUniqueId(),
            item_id: generateUniqueId(),
            order_id: generateUniqueId(),
        };
        setGenerateIds(newItem);
    };


    // const closeModal = () => {
    //     setOrderItem(undefined)
    // }
    const handleInnerFormChange: any = (event: any, field: string) => {
        setSelectedEstimateItem({ ...selectedEstimateItem, [field]: event });
    }

    const handleLeadSubmit = async () => {
        setSelectedEstimateItem({
            Name: selectedEstimateItem?.Name || '',
            PhoneNumber: selectedEstimateItem?.PhoneNumber || '',
            Pickup: pickupLocations?.description || '',
            Drop: dropLocations?.description || '',
            DropName: selectedEstimateItem?.DropName || '',
            DropPhoneNumber: selectedEstimateItem?.DropPhoneNumber || ''
        })
        setLeadItem(false)
    }

    const handleEstimate = (itemData: any) => {
        setSelectedVehicleItem({
            vehicleId: itemData?.Id,
            VehicleName: itemData?.VehicleName,
            VehicleType: itemData?.VehicleType,
            LoadingCapacity: itemData?.LoadingCapacity,
            Price: itemData?.Price,
            VehicleWeight: itemData?.VehicleWeight,
            RegistrationNumber: itemData?.RegistrationNumber,
            vehicleImageUrl: itemData?.MediaMappings?.MediaFiles[0]?.FileMappingURL
        })
        setOrderItem({
            id: 0
        })
    }

    //Step 2: Add Payment
    const handleOrderBooking = async () => {
        await setIsLoading(true)
        await dispatch(addPayment.update({
            url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/dom/check-outs/add-payment`, entity: 'addPayment', jsonData: {
                Records: [{
                    Context: {
                        transaction_id: quoteDetails?.result?.Records[0]?.context?.transaction_id,
                        message_id: generateIds?.message_id,
                    },
                    Message: {
                        Id: quoteDetails?.result?.Records[0]?.message?.order?.Id,
                        OwnerType: 'LogisticsOrder',
                        PaidAmount: quoteDetails?.result?.Records[0]?.message?.order?.quote?.breakup[0]?.price?.value,
                        PaymentRemarks: 'LogisticsOrder',
                        PaymentMethodId: selected, // Number(sessionStorage.getItem('paymentmethod')),
                        PaymentGatewayId: paymentGateway[0]?.Id || 0,
                    },
                }

                ],
            }
        }))
        await dispatch(orders.resetAction({ actionType: 'create' }))
        await setIsPaymentAdded(true);


    }
    // Step 3: Confirm Logistics Order
    useEffect(() => {
        if (isPaymentAdded) {
            const itemValues = quoteDetails?.result?.Records[0]?.message?.order?.items?.map((item: any) => {
                const data = {
                    id: item?.id,
                    fulfillment_id: item?.fulfillment_id,
                    category_id: item?.category_id,
                    descriptor: {
                        code: item?.descriptor?.code
                    },
                    time: {
                        label: null,
                        duration: item?.time?.duration || null,
                        timestamp: item?.time?.timestamp
                    }
                };
                return data;
            });

            const breakupValues = quoteDetails?.result?.Records[0]?.message?.order?.quote?.breakup?.map((item: any) => {
                const data = {
                    "@ondc/org/item_id": item?.['@ondc/org/item_id'],
                    "@ondc/org/title_type": item?.['@ondc/org/title_type'],
                    "price": {
                        "currency": item?.price?.currency,
                        "value": item?.price?.value
                    }
                };
                return data;
            });
            const fulfillmentValues = quoteDetails?.result?.Records[0]?.message?.order?.fulfillments?.map((item: any) => {
                const data = {
                    "id": item?.id,
                    "type": item?.type,
                    "@ondc/org/awb_no": null,
                    "start": {
                        "person": {
                            "name": ''
                        },
                        "location": {
                            "gps": item?.start?.location?.gps,
                            "address": {
                                "name": item?.start?.location?.address?.name,
                                "building": item?.start?.location?.address?.building,
                                "locality": item?.start?.location?.address?.locality,
                                "city": item?.start?.location?.address?.city,
                                "state": item?.start?.location?.address?.state,
                                "country": item?.start?.location?.address?.country,
                                "area_code": item?.start?.location?.address?.area_code
                            }
                        },
                        "contact": {
                            "phone": item?.start?.contact?.phone,
                            "email": item?.start?.contact?.email
                        },
                        "instructions": {
                            "code": null,
                            "short_desc": null,
                            "long_desc": null,
                            "additional_desc": {
                                "content_type": null,
                                "url": null
                            },
                            "images": null

                        },
                        "time": {
                            "label": null,
                            "duration": null,
                            "timestamp": null
                        }
                    },
                    "end": {
                        "person": {
                            "name": ''
                        },
                        "location": {
                            "gps": item?.end?.location?.gps,
                            "address": {
                                "name": item?.end?.location?.address?.name,
                                "building": item?.end?.location?.address?.building,
                                "locality": item?.end?.location?.address?.locality,
                                "city": item?.end?.location?.address?.city,
                                "state": item?.end?.location?.address?.state,
                                "country": item?.end?.location?.address?.country,
                                "area_code": item?.end?.location?.address?.area_code
                            }
                        },
                        "contact": {
                            "phone": item?.end?.contact?.phone || '',
                            "email": item?.end?.contact?.email || ''
                        },
                        "instructions": {
                            "code": null,
                            "short_desc": null,
                            "long_desc": null,
                            "additional_desc": {
                                "content_type": null,
                                "url": null
                            },
                            "images": null
                        },
                        "time": {
                            "label": null,
                            "duration": null,
                            "timestamp": null
                        }
                    },
                    "agent": {},
                    "vehicle": {
                        "vehicleId": item?.vehicle?.vehicleId,
                        "vehicleName": item?.vehicle?.vehicleName,
                        "vehicleType": item?.vehicle?.vehicleType,
                        "weight": item?.vehicle?.weight,
                        "registration": item?.vehicle?.registration,
                        "price": item?.vehicle?.price
                    },
                    "EWayBill": {
                        "MediaFiles": isOpenComponent ? mediaFiles : [],
                        "Templates": []
                    },
                    "@ondc/org/ewaybillno": null,
                    "@ondc/org/ebnexpirydate": null,
                    "tags": [
                        {
                            "code": null,
                            "list": [
                                {
                                    "code": null,
                                    "value": null
                                }
                            ]
                        }
                    ]
                };
                return data;
            });
            const linkedItemValues = quoteDetails?.result?.Records[0]?.message?.order?.LinkedItems?.map((item: any) => {
                let category = _.find(productTypesListItems?.result?.items, ['Id', item?.CategoryId]);
                let product = _.find(ProductLists?.result?.items, ['Id', item?.LogisticsProductId]);
                const data = {
                    "CategoryName": category?.Name,
                    "CategoryId": item?.CategoryId,
                    "LogisticsProductId": item?.LogisticsProductId,
                    "LogisticsVariantId": item?.LogisticsVariantId,
                    "descriptor": {
                        "name": product?.Name
                    },
                    "quantity": {
                        "count": item?.quantity?.count,
                        "measure": {
                            "unit": item?.quantity?.measure?.unit,
                            "value": item?.quantity?.measure?.value
                        }
                    },

                    "price": {
                        "currency": item?.value?.currency,
                        "value": item?.value?.value
                    },
                    "dangerous_goods": item?.dangerous_goods
                };
                return data;
            });
            const tagValues = quoteDetails?.result?.Records[0]?.message?.order?.tags?.map((item: any) => {
                const data = {
                    code: item?.code,
                    list: item?.list?.map((listItem: any) => {
                        const data = {
                            "code": listItem?.code,
                            "value": listItem?.value
                        }
                        return data;

                    })
                };
                return data;
            });
            const orderData = {
                context: {
                    transaction_id: quoteDetails?.result?.Records[0]?.context?.transaction_id,
                    message_id: generateIds?.fulfillment_id,
                },
                message: {
                    order: {
                        created_at: moment.utc(),
                        updated_at: moment.utc(),
                        id: generateIds.order_id,
                        state: null,
                        IsCargoOrder: true,
                        provider: {
                            id: quoteDetails?.result?.Records[0]?.message?.order?.provider?.id,
                            locations: quoteDetails?.result?.Records[0]?.message?.order?.provider?.locations
                        },
                        items: itemValues,
                        quote: {
                            price: {
                                currency: quoteDetails?.result?.Records[0]?.message?.order?.quote?.price?.currency,
                                value: quoteDetails?.result?.Records[0]?.message?.order?.quote?.price?.value,
                            },
                            breakup: breakupValues
                        },
                        fulfillments: fulfillmentValues,
                        "billing": {
                            "name": fulfillmentValues[0]?.start?.person?.name || '',
                            "address": {
                                "name": fulfillmentValues[0]?.start?.location?.address?.name || '',
                                "building": fulfillmentValues[0]?.start?.location?.address?.building || '',
                                "locality": fulfillmentValues[0]?.start?.location?.address?.locality || '',
                                "city": fulfillmentValues[0]?.start?.location?.address?.city || '',
                                "state": fulfillmentValues[0]?.start?.location?.address?.state || '',
                                "country": fulfillmentValues[0]?.start?.location?.address?.country || '',
                                "area_code": fulfillmentValues[0]?.start?.location?.address?.area_code || '',
                            },
                            "tax_number": '',
                            "phone": fulfillmentValues[0]?.start?.contact?.phone || '',
                            "email": fulfillmentValues[0]?.start?.contact?.email || '',

                        },
                        "payment": {
                            "@ondc/org/collection_amount": null,
                            "collected_by": null,
                            "type": null,
                            "@ondc/org/settlement_details": [
                                {
                                    "settlement_counterparty": null,
                                    "settlement_type": null,
                                    "upi_address": null,
                                    "settlement_bank_account_no": null,
                                    "settlement_ifsc_code": null
                                }
                            ]
                        },
                        "@ondc/org/linked_order": {
                            "items": linkedItemValues,
                            "provider": {
                                "descriptor": {
                                    "name": null
                                },
                                "address": {
                                    "name": organizationUnitLists?.result?.items[0]?.Name,
                                    "building": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.Address1,
                                    "locality": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.Address2,
                                    "city": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.City,
                                    "state": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.StateProvince?.Name,
                                    "country": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.Country?.Name,
                                    "area_code": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.ZipPostalCode
                                }
                            },
                            "order":
                            {
                                "id": null,
                                "weight": {
                                    "unit": "mm",
                                    "value": 600
                                },
                                "dimensions": {
                                    "length": {
                                        "unit": "mm",
                                        "value": 50
                                    },
                                    "breadth": {
                                        "unit": "mm",
                                        "value": 60
                                    },
                                    "height": {
                                        "unit": "mm",
                                        "value": 30
                                    }
                                }
                            }

                        },
                        "tags": tagValues,

                    }
                }
            }
            dispatch(orders.create({
                url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/confirm-logistics-order`,
                entity: 'orderCreate',
                jsonData: {
                    Records: [orderData]
                }
            })).then(() => {
                setIsLoading(false)
                setIsOrderPlaced(true);
            })
        }
    }, [isPaymentAdded])


    // Start- ccAvenue function
    const encrypt1 = (plainText: string, workingKey: string): string => {
        // Create an MD5 hash of the workingKey
        const key = CryptoJS.MD5(workingKey).toString(CryptoJS.enc.Hex);

        // Initialization vector (IV)
        const iv = CryptoJS.enc.Hex.parse('000102030405060708090a0b0c0d0e0f');

        // Encrypt the plainText
        const encrypted = CryptoJS.AES.encrypt(plainText, CryptoJS.enc.Hex.parse(key), {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });

        // Return the encrypted text in hex format
        return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
    };
    const handeCCAvenuePayment = (orderDetails: any) => {
        const workingKey =
            razorpaySettings.CCAvenue?.WorkingKey; //Put in the 32-Bit key shared by CCAvenues.
        const accessCode =
            razorpaySettings.CCAvenue?.AccessCode;
        const merchantId =
            razorpaySettings.CCAvenue?.MerchantId;

        const companyName = localStorage.getItem("CompanyName");
        const channelId = storePersist.get("accessTokenMetadata").current?.TokenMetadata?.SalesChannelId;
        const tenant = companyName; //getBusinessCompanyName();

        // const guestTokenData = {
        // 	Channel: channel.SalesChannelName, //SalesChannelName(),
        // 	Requester: `https://${tenant}.csp.digiit.${process.env.REACT_APP_API_URL}/`,
        // 	StoreId: storeId,
        // 	SalesChannelId: ChannelId,
        // };
        // const accessTokenData = {
        // 	PhoneNumber: userInfo[0]?.PhoneNumber,
        // 	TenantName: tenant,
        // 	SalesChannelId: ChannelId,
        // };
        const ccAvenueData = {
            merchant_id: merchantId,
            order_id: orderDetails?.order?.id,
            currency: 'INR',
            amount: Number(orderDetails?.order?.quote?.price?.value), //Total Price,
            //   ENABLE WHILE TESTING LOCALLY. NEEDS TO BE RUN ALONG WITH PAYMENTS REPO.
            //   redirect_url: `http://localhost:3004/${MODE}/${tenant}/${tenantId}/${storeId}/${channelId}/${billingAddress?.PhoneNumber}/ccavResponseHandler`,
            //   cancel_url: `http://localhost:3004/${MODE}/${tenant}/${tenantId}/${storeId}/${channelId}/${billingAddress?.PhoneNumber}/ccavResponseHandler`,

            // ENABLE FOR PRODUCTION
            redirect_url: `https://payments.digiit.${process.env.REACT_APP_API_URL}/${MODE}/${tenant}/${tenantId}/${storeId}/${channelId}/${userProfileData?.PhoneNumber}/ccavResponseHandler`,
            cancel_url: `https://payments.digiit.${process.env.REACT_APP_API_URL}/${MODE}/${tenant}/${tenantId}/${storeId}/${channelId}/${userProfileData?.PhoneNumber}/ccavResponseHandler`,

            language: 'EN',
            billing_name: orderDetails?.order?.billing?.address?.name,
            billing_address: orderDetails?.order?.billing?.address?.locality,
            billing_city: orderDetails?.order?.billing?.address?.city,
            billing_state: orderDetails?.order?.billing?.address?.state,
            billing_zip: orderDetails?.order?.billing?.address?.area_code,
            billing_country: orderDetails?.order?.billing?.address?.country,
            billing_tel: userProfileData?.PhoneNumber,
            billing_email: userProfileData?.Email,
            delivery_name: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.name,
            delivery_address: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.locality,
            delivery_city: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.city,
            delivery_state: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.state,
            delivery_zip: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.area_code,
            delivery_country: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.country,
            merchant_param1: tenant, //getOrganizationName(),
            merchant_param2: tenantId,
            merchant_param3: `${window.location.hostname}`,
            merchant_param4: 'cargo/order-details',
            merchant_param5: '',
            integration_type: 'iframe_normal',
            // promo_code:'PROMO8513',
            customer_identifier: userProfileData?.Email,
        };

        const body = queryString.stringify(ccAvenueData);

        const encRequest1 = encrypt1(body, workingKey);
        // let URL = `https://test.ccavenue.com/transaction/transaction.do?command=initiateTransaction&merchant_id=${ccAvenueData.merchant_id}6&encRequest=${encRequest1}&access_code=${accessCode}`;
        let URL = `https://${MODE}.ccavenue.com/transaction/transaction.do?command=initiateTransaction&merchant_id=${ccAvenueData.merchant_id}6&encRequest=${encRequest1}&access_code=${accessCode}`;
        window.location.href = URL;
        // router.push(URL);
        dispatch(cargoLeads.resetAction({ actionType: 'create' }))
    }

    useEffect(() => {
        if (isOrderPlaced) {
            switch (selected) {
                case 10: //cash payment
                    navigate('/cargo/order-details')
                    setOrderItem(undefined)
                    dispatch(cargoLeads.resetAction({ actionType: 'create' }))
                    break;
                case 20: //online
                    switch (paymentGateway[0]?.Id) {
                        case 10: //razorpay
                            // handeRazorpay()
                            break;
                        case 20: //ccavenue
                            handeCCAvenuePayment(orderDetails?.result?.items?.Records[0]?.message)
                            break;
                        case 30: //phonepe
                            break;
                        default:
                    }


                    break;
                case 30: //wallet
                    break;
            }

        }
    }, [isOrderPlaced])

    const NewEstimatePopup = ({ handleSavePackageItem, handleOrderBooking }: any) => {
        const [localPackItems, setLocalPackItems] = useState(deepCopy(selectedEstimateItem));
        const handleLocalFormChange = (value: any, field: any) => {
            setLocalPackItems((prev: any) => ({
                ...prev,
                [field]: value,
            }));
        };
        const handleFormSubmit = () => {
            if (
                !localPackItems?.CategoryId || !localPackItems?.ProductValue

            ) {
                toast.error("Please fill in Product Type and Product Value the details.");
                return; // Stop further execution if validation fails
            }
            setLocalPackItems(localPackItems);
            handleSavePackageItem(localPackItems)
        };
        const handleFormPayment = () => {
            handleOrderBooking()
        }
        const handlePaymentInput = (e: any, item: any) => {
            setSelected(item.value)
            setPaymentMode(item)
            setPaymentSelectedInput(e.target.value)
        }
        const closeModal = () => {
            setOrderItem(undefined)
            setIsOpenPayment(false)
            setEnableConfirm(false)
        }
        const handleFileURlSubmit = async (urlData) => {
            await setIsOpenPayment(true)
            await setMediaFiles(
                [{
                    Id: 0,
                    FileTypeId: urlData?.FileType === 'image' ? 10 : 20,
                    OwnerId: 0,
                    OwnerType: "shipping",
                    OwnerTypeId: 1007,
                    FileMappingURL: urlData?.DocumentPath
                }]
            )

        }
        return (
            <>
                <PopupMobile onClose={closeModal} onback={closeModal} >

                    {!enableConfirm ?
                        <ModalEstimateComponent
                            selectedEstimateItem={localPackItems}
                            selectedVehicleItem={selectedVehicleItem}
                            // handleEstimateBack={closeModal}
                            handleEstimateSubmit={handleFormSubmit}
                            pickupLocations={pickupLocations}
                            dropLocations={dropLocations}
                            productTypeCargo={productTypeCargo}

                            handleInnerFormChange={handleLocalFormChange}

                        /> : <>
                            {enableConfirm && isOpenComponent && !isOpenPayment ? <ModalEwayComponent
                                handleFileURlSubmit={handleFileURlSubmit}
                                selectedVehicleItem={selectedVehicleItem}
                                dropLocations={dropLocations}
                                pickupLocations={pickupLocations}
                                quoteDetails={quoteDetails} />
                                :
                                <ModalQuotesDetailsComponent

                                    selectedVehicleItem={selectedVehicleItem}
                                    dropLocations={dropLocations}
                                    pickupLocations={pickupLocations}
                                    quoteDetails={quoteDetails}
                                    enablePlaceOrder={enablePlaceOrder}
                                    handlePayment={handleFormPayment}
                                    isLoading={isLoading}
                                    paymentSettings={paymentSettings}
                                    paymentSelectedInput={paymentSelectedInput}
                                    handlePaymentInput={handlePaymentInput} />} </>}
                </PopupMobile>
            </>
        )
    }
    const handleEstimateleadSubmit = async (lead: any, pickup: any, drop: any) => {

        await setSelectedEstimateItem(lead)
        await setPickupLocations(pickup)
        await setDropLocations(drop)
        await handleLeadClose()
    };

    const handleLeadClose = () => {
        setLeadItem(false)
    }
    const NewLeadPopup = ({ handleEstimateleadSubmit }: any) => {
        const [localLead, setLocalLead] = useState(deepCopy(selectedEstimateItem));
        const [localPickup, setLocalPickup] = useState(deepCopy(pickupLocations));
        const [localDrop, setLocalDrop] = useState(deepCopy(dropLocations));

        const handleLocalFormChange = (value, field) => {
            setLocalLead(prev => ({
                ...prev,
                [field]: value,
            }));
            setLocalPickup(prev => ({
                ...prev,
                [field]: value,
            }));
            setLocalDrop(prev => ({
                ...prev,
                [field]: value,
            }));
        };

        const handleFormSubmit = () => {
            setLocalLead(localLead);
            handleEstimateleadSubmit(localLead, localPickup, localDrop)
        };

        return (
            <>
                <PopupMobile onback={handleLeadClose} onClose={handleLeadClose}>
                    <ModalLeadComponent
                        handleEstimateleadSubmit={handleFormSubmit}
                        selectedEstimateItem={localLead}
                        dropLocations={localDrop}
                        pickupLocations={localPickup}
                        setDropLocations={setLocalDrop}
                        setPickupLocations={setLocalPickup}
                        handleInnerFormChange={handleLocalFormChange}
                    />

                </PopupMobile>
            </>
        )
    }

    const onEdit = async () => {
        setLeadItem(true)
    }



    //Submit Quote
    const handleSavePackageItem = async (data: any) => {
        dispatch(cargoQuotes.resetAction({ actionType: 'create' }))
        await setIsLoading(true)
        // let shippingType = _.find(shippingTypesDetails.result.items, ['ShippingTypeName', 'Immediate Delivery']);
        let shippingType = shippingTypesDetails.result.items[0];
        const fromAddressData = _.split(pickupLocations?.description, ',');
        const toAddressData = _.split(dropLocations?.description, ',');
        const valueData = {
            order: {
                IsCargoOrder: true,
                provider: {
                    id: 0,
                    locations: []
                },
                items:
                    [{
                        id: String(shippingType?.Id) || 0,
                        fulfillment_id: generateIds?.fulfillment_id,
                        category_id: shippingType?.ShippingTypeName || "",
                        descriptor: {
                            code: "P2P" // shipmentType (library call)
                        },
                        time: {
                            label: "",
                            duration: result?.cargoLead?.time,
                            timestamp: result?.cargoLead?.date
                        }
                    }],
                billing: {},
                payment: {},
                LinkedItems: [{
                    CategoryId: data?.CategoryId,
                    LogisticsProductId: 0,
                    LogisticsVariantId: 0,
                    quantity: {
                        count: 0,
                        measure: {
                            unit: "kg",
                            value: 0
                        }
                    },
                    weight: {
                        unit: "mm",
                        value: 0
                    },
                    dimensions: {
                        length: {
                            unit: "mm",
                            value: 0
                        },
                        breadth: {
                            unit: "mm",
                            value: 0
                        },
                        height: {
                            unit: "mm",
                            value: 0
                        }
                    },
                    value: {
                        currency: "INR",
                        value: data?.ProductValue
                    },
                    dangerous_goods: false
                }],
                fulfillments: [
                    {
                        id: generateIds?.fulfillment_id,
                        type: 'Delivery_and_Self_Pickup',
                        start: {
                            location: {
                                gps: `${pickupLocations?.lat} ,${pickupLocations?.lng}`,
                                address: {
                                    name: selectedEstimateItem?.Name,
                                    building: fromAddressData[1],
                                    locality: `${fromAddressData[0]},${fromAddressData[1]}`,
                                    city: pickupLocations?.name,
                                    state: fromAddressData[3] || 'TamilNadu',
                                    country: 'India',
                                    area_code: pickupLocations?.pincode || ''
                                }
                            },
                            contact: {
                                phone: selectedEstimateItem?.PhoneNumber,
                                email: ''
                            }
                        },
                        end: {
                            location: {
                                gps: `${dropLocations?.lat} ,${dropLocations?.lng}`,
                                address: {
                                    name: selectedEstimateItem?.DropName,
                                    building: toAddressData[1],
                                    locality: `${toAddressData[0]},${toAddressData[1]}`,
                                    city: dropLocations?.name,
                                    state: toAddressData[3] || 'TamilNadu',
                                    country: 'India',
                                    area_code: dropLocations?.pincode || ''
                                }
                            },
                            contact: {
                                phone: selectedEstimateItem?.DropPhoneNumber,
                                email: ''
                            }
                        },
                        vehicle: {
                            vehicleId: selectedVehicleItem?.vehicleId,
                            vehicleName: selectedVehicleItem?.VehicleName,
                            vehicleType: selectedVehicleItem?.VehicleType,
                            weight: selectedVehicleItem?.VehicleWeight,
                            registration: selectedVehicleItem?.RegistrationNumber,
                            price: selectedVehicleItem?.Price
                        }
                    }
                ]
            }
        }

        await dispatch(cargoQuotes.create(
            {
                url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/logistics-quotes`, entity: 'quotes',
                jsonData: {
                    Records: [{
                        context: {
                            transaction_id: leadCreateData?.result?.Records[0]?.Context?.transaction_id,
                            message_id: generateIds?.item_id,
                        },
                        message: valueData,
                    }]
                }
            }))
        await setIsLoading(false)
        setEnableConfirm(true)

    }


    useEffect(() => {
        setRazorpaySettings(paymentMethodQuery?.result?.items?.RazorPayConfiguration);
    }, [paymentMethodQuery]);
    useEffect(() => {
        if (paymentMode) {
            if (paymentMode.name == 'Cash' || paymentMode.name == 'Wallet') {
                setPaymentGateway([]);
                setEnablePlaceOrder(true)
            } else if (paymentMode && razorpaySettings) {
                const gateways: any = []
                if (razorpaySettings?.RazorPay?.IsActive) {
                    gateways.push({ Id: 10, title: 'Razorpay', detail: 'Razorpay' })
                }
                if (razorpaySettings?.CCAvenue?.IsActive) {
                    gateways.push({ Id: 20, title: 'CC Avenue', detail: 'CC Avenue' })
                }
                if (razorpaySettings?.PhonePe?.IsActive) {
                    gateways.push({ Id: 30, title: 'PhonePe', detail: 'PhonePe' })
                }
                setPaymentGateway(gateways);
                setEnablePlaceOrder(true)
            } else {
                setEnablePlaceOrder(false)
            }
        }
    }, [paymentMode])

    useEffect(() => {
        generateIdValue()
        dispatch(vehicles.list({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/vehicle-registations/list`, entity: 'vehicles', jsonData: {

            }
        })).then(() => {
            dispatch(categories.list({
                url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/categories/list`,
                entity: 'categories',
                jsonData: {}
            }));
        }).then(() => {
            dispatch(shippingTypes.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/shipping-types/list`, entity: 'shippingTypes', jsonData: {} }))
        }).then(() => {
            dispatch(productTypes.list({ url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/product-types/list`, entity: 'productTypes', jsonData: {} }))
        })
    }, [])

    return (
        <div className='flex flex-col items-center my-36 px-4 w-full'>
            {leadItem ? <NewLeadPopup handleEstimateleadSubmit={handleEstimateleadSubmit}
            /> : <></>}
            <div className='bg-white h-auto flex flex-col w-full items-center justify-center mx-auto p-4'>
                <div className='w-full'>
                    <div className='p-2'>
                        <div className='font-semibold text-sm'>PickUp Address</div>
                        <div className='relative group'>
                            <div className='text-xs truncate w-full'>{pickupLocations?.description}</div>
                            <div className='absolute hidden group-hover:block bg-gray-700 text-white text-xs p-2 rounded shadow-lg max-w-xs'>
                                {pickupLocations?.description}
                            </div>
                        </div>
                    </div>
                </div>

                <div className='w-full border-t border-gray-500 my-2'></div>

                <div className='w-full'>
                    <div className='p-2'>
                        <div className='font-semibold text-sm'>Drop Address</div>
                        <div className='relative group'>
                            <div className='text-xs truncate w-full'>{dropLocations?.description}</div>
                            <div className='absolute hidden group-hover:block bg-gray-700 text-white text-xs p-2 rounded shadow-lg max-w-xs'>
                                {dropLocations?.description}
                            </div>
                        </div>
                    </div>
                </div>

                <div className='w-full border-t border-gray-500 my-2'></div>

                <div className='w-full'>
                    <div className='p-2'>
                        <div className='font-semibold text-sm'>Name</div>
                        <div className='text-xs w-full'>{selectedEstimateItem?.Name}</div>
                    </div>
                </div>

                <div className='w-full border-t border-gray-500 my-2'></div>

                <div className='w-full'>
                    <div className='p-2'>
                        <div className='font-semibold text-sm'>Phone Number</div>
                        <div className='text-xs w-full'>{selectedEstimateItem?.PhoneNumber}</div>
                    </div>
                </div>

                <button
                    onClick={onEdit}
                    type='button'
                    className='m-2 bg-primary text-light font-medium px-6 py-2 w-full text-center'>
                    Edit
                </button>
            </div>

            <div className='flex flex flex-col overflow-auto items-center pt-3 '>
                <div className='h-auto '>
                    {vehicleData?.result?.items.map((vehicleValue) => (
                        <VehicleCard
                            key={vehicleValue.id}
                            vehicle={vehicleValue}
                            handleEstimate={handleEstimate}
                        />
                    ))}
                </div>
            </div>
            {
                orderItem ? <NewEstimatePopup handleSavePackageItem={handleSavePackageItem} handleOrderBooking={handleOrderBooking} /> : <></>
            }
        </div>

    )
}

export default CargoOrderBookingMobile